import api from "./axios";

export const createQuotationApi = (data) =>
  api.post("/quotations", data);

export const getQuotationsApi = () =>
  api.get("/quotations");

export const deleteQuotationApi = (id) =>
  api.delete(`/quotations/${id}`);